/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Ticket } from '../../models/ticket';
import { TicketStatusUpdate } from '../../models/ticket-status-update';

export interface ApiTicketItemIdStatusPut$Params {
  item_id: number;
      body: TicketStatusUpdate
}

export function apiTicketItemIdStatusPut(http: HttpClient, rootUrl: string, params: ApiTicketItemIdStatusPut$Params, context?: HttpContext): Observable<StrictHttpResponse<Ticket>> {
  const rb = new RequestBuilder(rootUrl, apiTicketItemIdStatusPut.PATH, 'put');
  if (params) {
    rb.path('item_id', params.item_id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Ticket>;
    })
  );
}

apiTicketItemIdStatusPut.PATH = '/api/ticket/{item_id}/status';
